import { isPlatformBrowser } from '@angular/common';
import type { OnInit } from '@angular/core';
import {
	ChangeDetectorRef,
	Component,
	inject,
	PLATFORM_ID,
} from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

import { fallbackLanguage } from '@valk-nx/core/lib/core';
import { ObjectHelper } from '@valk-nx/helpers/lib/object/object.helper';
import { CountryService } from '@valk-nx/services/countries/src/lib/countries.service';

@Component({
	selector: 'formly-field-select',
	template: `
		<vp-dropdown
			[control]="formControl"
			[hasError]="showError"
			[inputId]="field.id"
			[isRequired]="props.required"
			[isValid]="formControl.valid && formControl.touched"
			[name]="field.key"
			[placeholder]="props.placeholder"
			[searchable]="props['searchable']"
			[selectData]="props['selectOptions']"
			[useAsFormControl]="true"
			[useAutoComplete]="props['useAutoComplete']"
			[value]="formControl.value"
			[variant]="props['variant']"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class SelectComponent
	extends FieldType<FieldTypeConfig>
	implements OnInit
{
	translate = inject(TranslateService);
	countryService = inject(CountryService);
	private readonly ref = inject(ChangeDetectorRef);
	private readonly platformId = inject(PLATFORM_ID);

	ngOnInit() {
		/* v8 ignore start */
		if (!isPlatformBrowser(this.platformId)) {
			return;
		}
		/* v8 ignore stop */

		if (
			this.field.props['selectType'] === 'country' ||
			this.field.props['selectType'] === 'giftcardCountries'
		) {
			this.countryService
				.getCountries(
					this.translate.getCurrentLang() ?? fallbackLanguage,
				)
				.pipe(take(1))
				.subscribe((response) => {
					let selectOptions = response;
					if (
						this.field.props['selectType'] === 'giftcardCountries'
					) {
						const giftcardOptions = this.field.props[
							'selectOptions'
						].map((option) => {
							return response.find(
								(giftcard) => giftcard.value === option.value,
							);
						});

						selectOptions = giftcardOptions;
					}

					this.field.props['selectOptions'] = selectOptions;
					this.ref.markForCheck();
				});
		} else if (this.field.props['selectType'] === 'arrivalTime') {
			this.field.props['selectOptions'] = ObjectHelper.getCheckInTimes(
				this.field.defaultValue,
			);

			this.ref.markForCheck();
		}
	}
}
